export class Snackbar {
	public message: string
	public code: number
}
